import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';

const SubmitButton = ({
  busy = false,
  textOnBusy,
  textOnIdle
}) => (
  <Button
    variant="raised"
    type="submit"
    color="primary"
    fullWidth={true}
    disabled={busy}
    className="auth__submit"
  >
    {busy ? textOnBusy : textOnIdle}
  </Button>
);

SubmitButton.propTypes = {
  busy: PropTypes.bool.isRequired,
  textOnBusy: PropTypes.string.isRequired,
  textOnIdle: PropTypes.string.isRequired,
};

export default SubmitButton;



// WEBPACK FOOTER //
// ./src/components/Authentication/components/SubmitButton.js